import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 368,
		y1: 368,
		x2: 144,
		y2: 144,
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 32
		}
	}), /* @__PURE__ */ _jsx("line", {
		x1: 368,
		y1: 144,
		x2: 144,
		y2: 368,
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 32
		}
	})]
});
export default SvgIClose;
